const { generate: genId } = require("shortid");

const assignIdsToHeaders = richTextFields =>
	richTextFields
		? richTextFields.map(field => {
				if (/^heading\d$/.test(field.type)) {
					field.id = `header-${genId()}`;
				}
				return field;
		  })
		: null;

const transformLinkGroup = group => ({
	id: genId(),
	header: group.primary ? assignIdsToHeaders(group.primary.title) : null,
	links: group.fields
		? group.fields.map(field => ({
				...field,
				id: genId(),
				url: field.url.url,
		  }))
		: null,
});

const transformDocumentGroup = group => ({
	id: genId(),
	header: group.primary ? assignIdsToHeaders(group.primary.title) : null,
	links: group.fields
		? group.fields.map(field => ({
				...field,
				id: genId(),
				url: `/Division/Research/Documents/${field.documentName}`,
		  }))
		: null,
});

module.exports = {
	assignIdsToHeaders: assignIdsToHeaders,
	transformLinkGroup: transformLinkGroup,
	transformDocumentGroup: transformDocumentGroup,
};
